export function nextTick(execute = () => {}) {
    Promise.resolve(true).then(execute)
}
